import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { queryKeys } from 'config/queryKeys'

export const useAddCommissionMutation = (removeNewCommission: () => void) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: addCommissionMutation, isPending: addCommissionIsLoading } = useMutation({
		mutationFn: (data) => {
			// TODO: change to apiRoutes
			return axiosPrivate.post('/settings/commission-rates/', data)
		},
		onSuccess: () => {
			queryClient
				.invalidateQueries({ queryKey: queryKeys.commissions.all })
				.then(() => removeNewCommission())
			useToast({
				type: 'success',
				message: t('Commission added')
			})()
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		}
	})

	return {
		addCommissionMutation,
		addCommissionIsLoading
	}
}
